import styles from './Partner.module.scss'

type Props = {
  contents: {
    certification: string
    number: string
  }[]
}

export const Partner: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.partner_container}>
      <div className={styles.main_container}>
        <div className={styles.top_container}>
          <p className={styles.partner_title_text}>AWSセレクトティアサービスパートナー認定による信頼と実績</p>
          <div className={styles.partner_image_container}>
            <img src={'/images/LP/LP202407/AmazonECS/img/Partner.png'} alt="" className={styles.partner_image} />
          </div>
        </div>
        <div className={styles.certification_container}>
          <p className={styles.certification_title}>AWS認定資格を取得した人数</p>
          <div className={styles.certification_table}>
            {contents.map((content) => (
              <div key={content.certification} className={styles.certification_table_row}>
                <p className={styles.certification_name}>{content.certification}</p>
                <img
                  src={'/images/LP/LP202407/AmazonECS/Icon/TableVector.svg'}
                  alt=""
                  className={styles.certification_number_vector}
                />
                <div className={styles.certification_number_container}>
                  <span className={styles.certification_number}>{content.number}</span>
                  <span className={styles.certification_number_unit}>人</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
